"use client";

import Image from "next/image";
import { useState } from "react";

/** The byline portrait, which removes itself if the file is not there.
 *
 *  The card used to test whether author_photo was SET, not whether it
 *  resolved, so a path pointing at nothing rendered a broken-image slot next
 *  to the name. That is an easy state to reach: uploads live in
 *  public/images/uploads, which is gitignored and server-local, so a path
 *  typed by hand or carried over from another environment is valid on one
 *  machine and a 404 everywhere else.
 *
 *  Whether a URL 404s cannot be known while rendering on the server without
 *  paying for a request per article, so the check happens where the answer is
 *  free — the browser already fetches the image, and onError is that fetch
 *  failing. Rendering null then returns the card to its text-only layout,
 *  which is a shape the design already accounts for.
 */
export function AuthorPhoto({ src, alt }: { src: string; alt: string }) {
  const [failed, setFailed] = useState(false);
  if (failed) return null;
  return (
    <Image
      src={src}
      alt={alt}
      width={180}
      height={180}
      sizes="86px"
      onError={() => setFailed(true)}
      className="h-[86px] w-[86px] shrink-0 rounded-[40px] object-cover"
    />
  );
}
